import { FloatingFormItem, PhoneFormField } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { Contact } from '@/core/domain/_shared/Contact';
import {
  ContactType,
  contactTypeOptions,
  contactTypeTranslate,
} from '@/core/domain/_shared/ContactType';
import { useDeleteCompanyContact } from '@/core/domain/enterprise/Companies/Companies.hooks';
import { useDefaultMaxLengthFieldError } from '@/hooks';
import { applyMask, removeMask } from '@/utils/mask';
import { cellphoneMask } from '@/utils/mask/commonMasks';
import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { useState } from 'react';
import { Plus, Trash2 } from 'react-feather';
import { FormattedMessage, useIntl } from 'react-intl';
interface Props {
  form: FormInstance;
}

export default function CompanyGeneralInfoContactForm(props: Props) {
  const intl = useIntl();
  const [previousValue, setPreviousValues] = useState<ContactType[]>([]);

  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const contactList = Form.useWatch('contactList', props.form);

  const contactDelete = useDeleteCompanyContact();

  const handleDeleteContact = (
    remove: (index: number | number[]) => void,
    index: number,
  ) => {
    const contact: Contact = contactList[index];

    if (!contact.value && !contact.id) {
      remove(index);

      setPreviousValues((prev) => {
        const newValues = [...prev];
        newValues.splice(index, 1);
        return newValues;
      });
      return;
    }

    Modal.confirm({
      title: 'Confirmação de Remoção',
      content: (
        <p>
          Tem certeza de que deseja remover o seguinte contato?
          <br /> <br />
          <span>{contactTypeTranslate[contact.contactType]}</span>: "
          <strong>
            {contact.contactType === 'EMAIL'
              ? contact.value
              : applyMask(removeMask(contact.value), cellphoneMask)}
          </strong>
          "
        </p>
      ),
      onOk: async () => {
        if (!!contact.id) await contactDelete.mutateAsync(contact.id);

        remove(index);

        setPreviousValues((prev) => {
          const newValues = [...prev];
          newValues.splice(index, 1);
          return newValues;
        });
      },
      okType: 'danger',
      okText: 'Remover',
      width: 500,
    });
  };

  return (
    <Form.List name="contactList">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }, index) => (
            <Row
              align="top"
              gutter={[12, 12]}
              style={{ marginBottom: 12 }}
              key={index}
            >
              <Col span={24} md={11} lg={6}>
                <Form.Item noStyle shouldUpdate>
                  {({ setFieldValue }) => (
                    <FloatingFormItem
                      {...restField}
                      parentFieldName="contactList"
                      fieldKey={[name, 'contactType']}
                      name={[name, 'contactType']}
                      label={
                        <FormattedMessage id="companies.general.form.contacts.contactType" />
                      }
                      style={{ margin: 0 }}
                      initialValue={ContactType.Mobile}
                    >
                      <Select
                        options={contactTypeOptions}
                        onChange={(value) => {
                          if (value === ContactType.Email) {
                            setFieldValue(['contactList', name, 'value'], '');
                          } else if (
                            previousValue[index] === ContactType.Email &&
                            value !== ContactType.Email
                          ) {
                            setFieldValue(['contactList', name, 'value'], '');
                          }

                          setPreviousValues((prev) => {
                            const newValues = [...prev];
                            newValues[index] = value;
                            return newValues;
                          });
                        }}
                      />
                    </FloatingFormItem>
                  )}
                </Form.Item>
              </Col>

              <Col span={22} md={11} lg={6}>
                <Form.Item noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const contactType =
                      getFieldValue(['contactList', index, 'contactType']) ??
                      ContactType.Mobile;

                    if (contactType === ContactType.Email) {
                      return (
                        <FloatingFormItem
                          {...restField}
                          parentFieldName="contactList"
                          fieldKey={[name, 'value']}
                          name={[name, 'value']}
                          rules={[
                            {
                              type: 'email',
                              message: intl.formatMessage({
                                id: 'commons.form.errors.invalidEmail',
                              }),
                              required: true,
                            },
                            defaultMaxLenghtFieldError(100),
                          ]}
                          label={
                            <FormattedMessage id="commons.contact.contactType.email" />
                          }
                        >
                          <Input />
                        </FloatingFormItem>
                      );
                    } else {
                      return (
                        <PhoneFormField
                          parentFieldName="contactList"
                          name={[name, 'value']}
                          fieldKey={[name, 'value']}
                          label={
                            <FormattedMessage
                              id={`commons.contact.contactType.${contactType.toLowerCase()}`}
                            />
                          }
                        />
                      );
                    }
                  }}
                </Form.Item>
              </Col>

              <Col span={2} md={2} lg={2}>
                {key !== undefined ? (
                  <Button
                    type="link"
                    style={{ height: 48 }}
                    onClick={() => handleDeleteContact(remove, index)}
                  >
                    <AntdFeatherIcon icon={<Trash2 color="red" />} />
                  </Button>
                ) : null}
              </Col>
            </Row>
          ))}

          <Form.Item style={{ marginTop: 12 }}>
            <Button
              type="link"
              onClick={() => {
                add();

                setPreviousValues((prev) => {
                  const newValues = [...prev];
                  newValues[fields.length] = ContactType.Mobile;
                  return newValues;
                });
              }}
              icon={<AntdFeatherIcon icon={<Plus />} size={12} />}
            >
              Adicionar Contato
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
}
